import { ProfilePageTabId } from '@colonist/clientforge';
import { UIAjaxWrapper } from '../../../shared/scripts/network/UIAjaxWrapper.ts';
import { UIAPIEndpoints } from '../../../shared/scripts/network/UIAPIEndpoints.ts';
import { UIComponentDropdownController } from '../../../shared/scripts/ui_components/UIComponentDropdownController.ts';
import { showReportPlayerDialog } from '../../../shared/scripts/ui_popup/showReportPlayerDialog.ts';
import { UIProfileFriendsTableController } from '../../../shared/scripts/profile/UIProfileFriendsTableController.ts';
import { UIUtilsFriends } from '../../../shared/scripts/ui_friends/UIUtilsFriends.ts';
import { ViewPopupLogin } from '../../../shared/scripts/ui_popup/ui_popup_membership_incentive/ViewPopupLogin.ts';
import { ClientUserState } from '../../../shared/scripts/ClientUserState.ts';
import { doActionIfCanGiftMembership } from '../../../shared/scripts/store/StoreUtils.ts';
import { AnalyticEventCategory, AnalyticEventType, GiftMembershipMethod } from '../../../../shared/entity_datas/EntityDatas.ts';
import { CA } from '../../../shared/scripts/analytics/Analytics.ts';
import { LobbyImage } from '@colonist/types';
import { navigateToPage } from '../ui_utils/ClientUtils.ts';
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
import { getProfilePopupElementId } from './UIViewProfilePopup.ts';
export class UIProfileFriendsController {
    async init() {
        this.profileIsCurrentUser = this.isProfileCurrentUser();
        if (!this.profileIsCurrentUser) {
            this.hideFriendsTab();
            this.redirectIfFriendSectionIsActive();
        }
        this.userFriendsData = await UIUtilsFriends.getFriends(ClientUserState.userState);
        if (!this.isPopup) this.profileLinkController.markApiCallMade(ProfilePageTabId.Friends);
        await this.createDropdown();
        if (this.isPopup) return;
        new UIProfileFriendsTableController(this.userFriendsData);
    }
    setUsername(username) {
        this.username = username;
    }
    hideFriendsTab() {
        this.profileLinkController.setTabVisible(ProfilePageTabId.Friends, false);
    }
    showFriendsTab() {
        this.profileLinkController.setTabVisible(ProfilePageTabId.Friends, true);
    }
    redirectIfFriendSectionIsActive() {
        if (this.profileLinkController.activeTabId != ProfilePageTabId.Friends) return;
        navigateToPage(`/profile/${this.username}`);
    }
    isProfileCurrentUser() {
        var _ClientUserState_userState;
        return ((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.username.toLowerCase()) == decodeURIComponent(this.username.toLowerCase());
    }
    async createDropdown() {
        const friendDropdownContent = this.getInitialDropdownContentForUserFriendsData();
        this.profileDropdownContent = this.getDropdownContent(friendDropdownContent);
        if (this.toggleVisibilityComponent == undefined) return;
        const dropdownParentId = getProfilePopupElementId('sticky_player_info_text_container', this.isPopup);
        this.dropdownController = new UIComponentDropdownController(this.profileDropdownContent, dropdownParentId, this.profileIsCurrentUser, this.toggleVisibilityComponent);
        this.dropdownController.dropdownView.style.left = '0';
    }
    getDropdownContent(friendDropdownContent) {
        const dropdownContent = [];
        if (!UIUtilsEjsVariables.isUserOnDiscordMobile) {
            dropdownContent.push({
                id: getProfilePopupElementId('profile_dropdown_gift_membership', this.isPopup),
                class: '',
                text: {
                    key: 'strings:storePage.sendGift'
                },
                action: ()=>this.sendGiftDropdownAction(),
                icon: LobbyImage.StoreGiftMembershipDark
            });
        }
        dropdownContent.push({
            id: getProfilePopupElementId('profile_dropdown_report', this.isPopup),
            class: 'component-dropdown-red',
            text: {
                key: 'strings:game.endGame.report'
            },
            action: ()=>void this.reportProfileDropdownAction()
        });
        if (!ClientUserState.hasUser()) return dropdownContent;
        if (this.isFriendOrPending) {
            dropdownContent.push(friendDropdownContent);
        } else {
            dropdownContent.unshift(friendDropdownContent);
        }
        return dropdownContent;
    }
    getInitialDropdownContentForUserFriendsData() {
        if (this.userFriendsData == undefined) return this.friendStateDropdownContent.notFriend;
        if (this.userFriendsData.friends.some((friend)=>friend.username == this.username)) {
            this.isFriendOrPending = true;
            return this.friendStateDropdownContent.friend;
        }
        if (this.userFriendsData.friendRequestsSent.some((friendRequest)=>friendRequest.username == this.username)) {
            this.isFriendOrPending = true;
            return this.friendStateDropdownContent.pending;
        }
        return this.friendStateDropdownContent.notFriend;
    }
    sendGiftDropdownAction() {
        const giftButtonClickEventData = {
            type: AnalyticEventType.ABTestClickAnalytics,
            category: AnalyticEventCategory.GiftMembershipOverlay,
            floatValue: GiftMembershipMethod.PlayerProfile
        };
        void CA.sendAnalyticEvent(giftButtonClickEventData);
        const url = (UIUtilsEjsVariables.isUserOnDiscord && this.isPopup ? 'https://colonist.io' : '') + `/store?username=${this.username}#gift`;
        doActionIfCanGiftMembership(()=>navigateToPage(url, true), this.username);
    }
    async addFriendDropdownAction() {
        const updateDropdownOnSuccess = (becameFriends)=>{
            const dropdownElement = document.getElementById(getProfilePopupElementId('profile_dropdown_add_friend', this.isPopup));
            if (dropdownElement == undefined) return;
            dropdownElement.remove();
            const newDropdownContent = becameFriends ? this.friendStateDropdownContent.friend : this.friendStateDropdownContent.pending;
            this.dropdownController.createDropdownContentElement(newDropdownContent);
        };
        void UIUtilsFriends.addFriendAction(decodeURIComponent(this.username), updateDropdownOnSuccess);
    }
    showRemoveFriendPopup() {
        const removeFriendPopupAction = ()=>{
            const updateDropdownOnSuccess = ()=>{
                const dropdownElement = document.getElementById(getProfilePopupElementId('profile_dropdown_removeFriend', this.isPopup));
                if (dropdownElement == undefined) return;
                dropdownElement.remove();
                this.dropdownController.createDropdownContentElement(this.friendStateDropdownContent.notFriend);
            };
            void UIUtilsFriends.removeFriendAction(this.username, updateDropdownOnSuccess);
        };
        UIUtilsFriends.showRemoveFriendPopup(this.username, removeFriendPopupAction);
    }
    async reportProfileDropdownAction() {
        var _ClientUserState_userState;
        if (!((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.isLoggedIn)) {
            new ViewPopupLogin();
            return;
        }
        const reportPopupAction = (playerName, reportReason)=>{
            const userReportData = {
                reason: reportReason
            };
            void UIAjaxWrapper.postRequestHandler(UIAPIEndpoints.apiReportPlayer(playerName), undefined, userReportData, 'application/json');
        };
        showReportPlayerDialog(this.username, reportPopupAction, false);
    }
    constructor(username, profileLinkController, toggleVisibilityComponent, isPopup = false){
        this.profileDropdownContent = [];
        this.isFriendOrPending = false;
        this.username = username;
        this.profileLinkController = profileLinkController;
        this.toggleVisibilityComponent = toggleVisibilityComponent;
        this.isPopup = isPopup;
        this.friendStateDropdownContent = {
            friend: {
                id: getProfilePopupElementId('profile_dropdown_removeFriend', this.isPopup),
                class: 'component-dropdown-red',
                text: {
                    key: 'strings:profilePage.friends.removeFriend.title'
                },
                action: ()=>void this.showRemoveFriendPopup()
            },
            notFriend: {
                id: getProfilePopupElementId('profile_dropdown_add_friend', this.isPopup),
                class: '',
                text: {
                    key: 'strings:game.playerOptionsPopup.addFriend'
                },
                action: ()=>void this.addFriendDropdownAction()
            },
            pending: {
                id: getProfilePopupElementId('profile_dropdown_pending', this.isPopup),
                class: 'component-dropdown-disabled',
                text: {
                    key: 'strings:profilePage.friends.friendRequestSent'
                }
            }
        };
        void this.init();
    }
}
